var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldMapPinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3658 0.394283C7.86289 0.394283 0.98584 7.27134 0.98584 15.7743C0.98584 27.3093 16.3658 44.3371 16.3658 44.3371C16.3658 44.3371 31.7458 27.3093 31.7458 15.7743C31.7458 7.27134 24.8688 0.394283 16.3658 0.394283ZM16.3658 21.2671C13.3338 21.2671 10.873 18.8063 10.873 15.7743C10.873 12.7422 13.3338 10.2814 16.3658 10.2814C19.3979 10.2814 21.8587 12.7422 21.8587 15.7743C21.8587 18.8063 19.3979 21.2671 16.3658 21.2671Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMapPinBlack);
export default __webpack_public_path__ + "static/media/world-map-pin-black.1a31a2cda09fe969ae6a7078eada3690.svg";
export { ForwardRef as ReactComponent };